import { useTranslation } from "../../i18n/useTranslation";
import styles from './ContactUsSuccess.module.scss';

const ContactUsSuccess: React.FC = () => {
    const { t } = useTranslation('translation');

    return (
        <>
            <div className={styles.container}>
                <div className={styles.row}>
                    <label className={styles.h1}>{t('MESSAGE_SENT')}</label>
                </div>
                <div className={styles.row}>
                    <label className={styles.h2}>{t('CONTACT_US_MESSAGES.MESSAGE_1')}</label>
                </div>
            </div>
        </>
    );
};

export default ContactUsSuccess;